import { useQuery } from '@tanstack/react-query';
import apiClient from '@/api-client';

export interface SystemLog {
  id: string;
  timestamp: string;
  level: string;
  service: string;
  threads: string;
  message: string;
  integrationUuid?: string;
  agentId?: string;
  conversationId?: string;
  customerId?: string;
  interactionId?: string;
  params: Record<string, any>;
  stack?: string;
  thread?: Record<string, any>;
}

export interface SystemLogsResponse {
  data: SystemLog[];
  total: number;
}

export const systemLogsKeys = {
  all: ['systemLogs'] as const,
  lists: () => [...systemLogsKeys.all, 'list'] as const,
  list: (query?: string) => [...systemLogsKeys.lists(), { query }] as const,
};

export function useSystemLogsList(query?: string) {
  return useQuery({
    queryKey: systemLogsKeys.list(query),
    queryFn: async (): Promise<SystemLogsResponse> => {
      const queryString = query ? `?${query}` : '';
      const response = await apiClient.get(`/system-logs${queryString}`);
      return response.data;
    },
    staleTime: 30 * 1000,
    gcTime: 2 * 60 * 1000,
  });
}
